import {
    request
} from "./request";

// Retrieve splicing event psi values by event_id and project_id
export function findPSIByEventAndCancer(eventid, projectid) {
    return request({
        url: '/ascancer/api/regexp/psi',
        params: {
            eventid,
            projectid
        },
    })
}

export function getMutationPvalues(data) {
    return request({
        method: 'post',
        url: '/ascancer/api/regexp/mut/pval',
        data: data,
    })
}

export function getExpressionPvalues(data) {
    return request({
        method: 'post',
        url: '/ascancer/api/regexp/exp/pval',
        data: data,
    })
}

export function getPsiExpressionScatter(data) {
    return request({
        method: 'post',
        url: '/ascancer/api/regexp/exp/scatter',
        data: data,
    })
}


// Retrieve TCGA samples mutations by projectid and gene_name
export function findMutationByGeneAndCancer(projectid, genename) {
    return request({
        url: '/ascancer/api/regexp/mut',
        params: {
            projectid,
            genename
        },
    })
}

// Retrieve TCGA samples mutations gene_name by projectid
export function findMutationGeneByCancer(projectid) {
    return request({
        url: '/ascancer/api/regexp/mut/byproject',
        params: {
            projectid
        },
    })
}


// Retrieve TCGA samples CNV by projectid and gene_name
export function findCNVByGeneAndCancer(projectid, genename) {
    return request({
        url: '/ascancer/api/regexp/cnv',
        params: {
            projectid,
            genename
        },
    })
}

// Retrieve TCGA samples expression by projectid and gene_name
export function findExpressionByGeneAndCancer(projectid, genename) {
    return request({
        url: '/ascancer/api/regexp/exp',
        params: {
            projectid,
            genename
        },
    })
}

// Retrieve TCGA samples mutations gene_name by projectid
export function findExpressionGeneByCancer(projectid) {
    return request({
        url: '/ascancer/api/regexp/exp/byproject',
        params: {
            projectid
        },
    })
}

// Retrieve splicing event mutation p-value values by event_id and project_id
// export function findMutationPvalueByEventAndCancer(projectid, eventid) {
//     return request({
//         url: '/ascancer/api/regexp/mut/pval',
//         params: {
//             projectid,
//             eventid
//         },
//     })
// }

// Retrieve splicing event expression p-value values by event_id and project_id
// export function findExpressionPvalueByEventAndCancer(projectid, eventid) {
//     return request({
//         url: '/ascancer/api/regexp/exp/pval',
//         params: {
//             projectid,
//             eventid
//         },
//     })
// }